import React, { useCallback, useEffect, useState } from 'react'
import { Flex, Box } from 'reflexbox'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'

import Breadcrumb from 'components/Breadcrumb'
import Card from 'components/Card'
import Loader from 'components/Loader'
import { Title, Text } from 'components/Typography'
import { CheckboxGroup, TextField } from 'components/Form'
import Button from 'components/Button'

import { useUser } from 'context/user-context'
import { getPackagesBalance } from 'services/orders'
import { createGroup } from 'services/groups'

const breadcrumbPath = [
  {
    label: 'Grupo de beneficiários',
    link: '/prepaid-purchase/groups',
  },
  {
    label: 'Adicionar Grupo de Beneficiários',
  },
]

const validationSchema = Yup.object().shape({
  group_name: Yup.string().required(),
  packages: Yup.array().required(),
})

const New = () => {
  const [packages, setPackages] = useState([])
  const [isPakagesLoading, setIsPackagesLoading] = useState(false)
  const [isRequesting, setIsRequesting] = useState(false)

  const handleSubmit = async ({ group_name, packages }, { resetForm }) => {
    try {
      setIsRequesting(true)

      const formattedValues = {
        name: group_name,
        packages: packages.map(package_id => Number(package_id)),
      }

      await createGroup(formattedValues)
      resetForm()
      toast.success('Cadastro realizado com sucesso!')
    } catch (e) {
      console.log(e)
      if (e?.response?.status === 400) toast.error('Plano básico é obrigatório!')
      else toast.error('Não foi possivel realizar o cadastro no momento.')
    } finally {
      setIsRequesting(false)
    }
  }

  useEffect(() => {
    const getBalance = async () => {
      try {
        setIsPackagesLoading(true)
        const { data } = await getPackagesBalance()

        const formattedData = data.data.map(plan => {
          return {
            label: `${plan.package}(${plan.balance})`,
            value: `${plan.id}`,
          }
        })

        setPackages(formattedData)
      } catch (e) {
        console.log(e)
        toast.error('Não foi possivel carregar os pacotes no momento!')
      } finally {
        setIsPackagesLoading(false)
      }
    }

    getBalance()
  }, [])

  return (
    <Flex flexDirection='column' width={1}>
      <Breadcrumb children={breadcrumbPath} />
      <Title as='h3'>Adicionar Grupo de Beneficiários</Title>

      <Formik
        initialValues={{ group_name: '', packages: '' }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Card mt={24}>
          <Flex flexDirection='column'>
            <Form>
              <Box width={(1, '280px')}>
                <TextField name='group_name' label='Nome do grupo' placeholder='Nome do grupo' />
                {isPakagesLoading ? (
                  <Flex justifyContent='center' alignItems='center' width={280} height={130}>
                    <Loader />
                  </Flex>
                ) : packages.length === 0 ? (
                  <Flex justifyContent='center' alignItems='center' width={280} height={130}>
                    <Text>Antes de cadastrar um grupo você deve comprar pacotes de canais.</Text>
                  </Flex>
                ) : (
                  <CheckboxGroup my={24} name='packages' label='Selecionar pacote de canais' options={packages} />
                )}
              </Box>
              <Flex width={(1, '584px')} justifyContent='space-between'>
                <Button type='button' size='big' outlined as={Link} to='/prepaid-purchase/groups'>
                  Voltar
                </Button>
                <Button disabled={isRequesting} type='submit' size='big'>
                  {isRequesting ? <Loader /> : 'Salvar'}
                </Button>
              </Flex>
            </Form>
          </Flex>
        </Card>
      </Formik>
    </Flex>
  )
}

export default New
